import { render } from "./addActivity.vue?vue&type=template&id=8f16146c"
import script from "./addActivity.vue?vue&type=script&lang=js"
export * from "./addActivity.vue?vue&type=script&lang=js"

import "./addActivity.vue?vue&type=style&index=0&id=8f16146c&lang=less"
script.render = render

export default script